<template>
    <common-page flex-column>
        <!-- 项目信息 -->
        <div id="project-info" class="content" v-if="!isQueryAll">
            <div class="card">
                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                     data-parent="#accordionFilter">
                    <div class="card-body">
                        <div class="bs-component"></div>
                        <div class="d-flex flex-row">
                            <h5><span class="text-primary">项目信息</span></h5>
                        </div>
                        <div class="d-flex flex-row">
                            <div class="col-3">
                                <key-value-cell :value="projectCode" horizontal>项目号</key-value-cell>
                            </div>
                            <div class="col-6">
                                <key-value-cell :value="projectName" horizontal>项目名称</key-value-cell>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 添加KAM选项 -->
        <div id="add-kam" class="content mt-1" v-if="!isKamChange && isEn && !isQueryAll">
            <div class="card">
                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                     data-parent="#accordionFilter">
                    <div class="card-body">
                        <div class="bs-component"></div>
                        <div class="col-lg-12 d-flex flex-row">
                            <h5><span class="text-primary">挑KAM</span></h5>
                        </div>
                        <div class="col-lg-12 d-flex flex-row">
                            <button class="btn btn-outline-secondary col-2" title="从KAM基础选择"
                                    @click="openSelectDialog()">从KAM基础选择
                            </button>
                            <button class="btn btn-outline-secondary ml-2 col-2" title="从其他项目复制"
                                    @click="openCopyDialog()">从其他项目复制
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- KAM展示 -->
        <div class="card mt-1 p-2 flex-grow-1 overflow-auto" v-if="!isKamChange">
            <h5><span class="text-primary position-absolute">{{ isQueryAll ? 'All KAM' : '已选KAM' }}</span></h5>
            <b-overlay :show="savingProjectKam || queryCurrentKamListLoading" class="h-98">
                <mini-table ref="currentKamListTable"
                            class="mt-1"
                            :items="currentKamList"
                            need-model-fields
                            entity-name="sithMesPrdProjectKam"
                            :custom-vuex-name="(isQueryAll ? 'allInfoView' : 'listView') + (isEn ? 'EN' : '')"
                            :fields="editTableFields"
                            disable-first-index-column
                            read-only sortable
                            edit-data-with-fields="kamId"
                            with-custom-actions-end-of-row
                            @rowClick="whenCurrentKamListRowClick"
                            :use-inline-delete-btn="row=>editAble && isEn && !hasCode(row.materialNumber)">
                    <template #rightHeader>
                        <b-button class="ml-1" variant="success"
                                  :disabled="savingProjectKam"
                                  v-show="editAble"
                                  @click="saveProjectKam()">
                            保 存
                        </b-button>
                        <b-button class="ml-1 mr-1" :variant="editAble ? 'outline-warning' : 'outline-success'"
                                  v-if="(isEn || isOm) && currentKamList.length > 0"
                                  @click="triggerTableEdit()">
                            {{ editAble ? '关闭编辑' : '开启编辑' }}
                        </b-button>
                    </template>
                    <template #endOfRow="{row}">
                        <!--                        <b-button variant="danger" v-if="editAble && isEn && !hasCode(row.materialNumber)"-->
                        <!--                                  @click="deleteSelectedRow(row)">-->
                        <!--                            <i class="fa-solid fa-trash-can"></i>-->
                        <!--                        </b-button>-->
                        <b-button variant="outline-primary" v-if="isOm && !row.isLocked"
                                  :disabled="editAble"
                                  @click="lockProjectKam(row)">
                            <i class="fa-solid fa-lock-open"></i>
                        </b-button>
                        <b-button variant="primary" v-if="isOm && row.isLocked"
                                  :disabled="editAble"
                                  @click="unlockProjectKam(row)">
                            <i class="fa-solid fa-lock"></i>
                        </b-button>
                    </template>
                </mini-table>
            </b-overlay>

        </div>
        <div class="card mt-1 p-2" v-if="selectedProjectKam!=null">
            <h5><span class="text-primary">Kam Change</span></h5>
            <div class="d-flex flex-row">
                <key-value-cell class="col-3" :value="selectedProjectKam.materialNumber" horizontal>
                    选择的物料号
                </key-value-cell>
                <key-value-cell v-if="selectedBomItem!=null" class="col-4" :value="selectedBomItem.componentNumber"
                                horizontal>
                    选择的BOM Item
                </key-value-cell>
                <b-button-group class="ml-auto">
                    <em-button type="search"
                               class="btn btn-outline-primary btn-sm"
                               custom-label="查看BOM"
                               show-name
                               :busy="queryBomLoading"
                               @click="queryBom">
                    </em-button>
                    <em-button type="search"
                               class="btn btn-outline-primary btn-sm"
                               custom-label="发起Change"
                               show-name
                               :busy="createKamChangeLoading"
                               @click="$refs.chooseChangeType.showModal()">
                    </em-button>
                    <em-button type="gotoChild"
                               v-if="createdKamChange"
                               class="btn btn-outline-primary btn-sm"
                               custom-label="去Kam Change待办"
                               @click="routeToKamChange">
                    </em-button>
                </b-button-group>
            </div>
        </div>
        <div class="card mt-1 p-2" v-if="bomMaterialList.length>0">
            <div class="d-flex flex-row">
                <h5><span class="text-primary">BOM Structure</span></h5>
                <button type="button"
                        class="close ml-auto mr-1 mb-1"
                        @click="cancelBomItemSelect"
                        aria-label="关闭">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <mini-table read-only
                        :items="bomMaterialList"
                        enable-origin-field
                        @rowClick="selectBomRow">
            </mini-table>
        </div>
        <div class="card mt-1 p-2 flex-grow-1 overflow-auto" v-if="isKamChange">
            <h5><span class="text-primary position-absolute">已选Kam</span></h5>
            <mini-table read-only
                        style="height: 98% !important;"
                        entity-name="sithMesPrdProjectKam"
                        custom-vuex-name="listView"
                        :items="currentKamList"
                        need-model-fields
                        @rowClick="toKamChange"></mini-table>
        </div>
        <template #outer>
            <!-- select kam dialog -->
            <re-b-modal header="挑KAM" @hide="clearFilter()"
                        ref="selectKam" super-large
                        @ok="assignKamToProject()">
                <div class="d-flex flex-column h-100">
                    <!-- 筛选框部分 -->
                    <div class="w-100 position-sticky top bg-white">
                        <div class="d-flex flex-row justify-content-center mb-1">
                            <template v-for="(item,index) of selectKamFilterConfig">
                                <diverse-input :key="index"
                                               class="ml-1 w-25"
                                               :value.sync="kamFilter[item.name]"
                                               :config="item.config"></diverse-input>
                            </template>
                        </div>
                        <div class="d-flex flex-row justify-content-center">
                            <el-button type="primary" plain @click="searchKam" icon="el-icon-search" size="mini"
                                       :loading="inQuery">查询
                            </el-button>
                            <el-button type="warning" plain @click="resetFilter" icon="el-icon-delete" size="mini">
                                重置
                            </el-button>
                        </div>
                    </div>
                    <!-- 显示KAM部分 -->
                    <div class="mt-1 d-flex flex-row flex-grow-1 w-100 overflow-auto">
                        <div class="row w-100 h-100">
                            <div class="col-6 h-100">
                                <mini-table :fields="kamSelectTableFieldConfig" :items="kamList" read-only
                                            @rowClick="chooseKam"></mini-table>
                            </div>
                            <div class="col-6 h-100">
                                <mini-table :fields="kamSelectTableFieldConfig" :items="choosenKam" read-only
                                            header-title="已选择"
                                            @rowClick="handleDelete"></mini-table>
                            </div>
                        </div>
                    </div>
                </div>
            </re-b-modal>

            <!-- copy kam from project -->
            <el-dialog title="复制KAM" :visible.sync="copyKamDialogVisible" width="66%" :close-on-click-modal='false'
                       append-to-body
                       @close='clearCopyFilter'>
                <!-- 筛选框部分 -->
                <div>
                    <el-form :model="copyKamFilter" ref="copyKamFilterForm" label-width="auto" size="mini"
                             @submit.native.prevent>
                        <el-row :gutter="10">
                            <el-col :span="6">
                                <el-form-item label="项目号">
                                    <el-input v-model="copyKamFilter.projectCode" @change="searchProjectKam"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-button type="primary" plain @click="searchProjectKam" icon="el-icon-search"
                                           size="mini"
                                           :loading="inSearchProjectKam">查询
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <!-- 显示项目KAM部分 -->
                <div style="margin-top:10px;">
                    <div class="tree-bom-div">
                        <el-tree ref="copyKamTree" :data="projectKamList" :props="defaultProps" default-expand-all
                                 show-checkbox node-key="id"
                                 empty-text="输入项目号搜索"></el-tree>
                    </div>
                    <div class="mt-1 d-flex flex-row">
                        <el-button class="ml-auto" @click="copyKamDialogVisible=false">取消</el-button>
                        <el-button class="ml-1" type="primary" @click="copyKamToProject()">确认</el-button>
                    </div>
                </div>
            </el-dialog>

            <re-b-modal ref="chooseChangeType" header="选择变更类型"
                        @ok="createKamChange"
                        @hide="changeType=null">
                <b-button-group class="w-100">
                    <b-button v-for="item of changeTypes" :key="item.value"
                              :variant="(changeType === item.value ? '' : 'outline-') + 'primary'"
                              @click="changeType=item.value">
                        {{ item.text }}
                    </b-button>
                </b-button-group>
            </re-b-modal>
        </template>
    </common-page>
</template>
<script>
import emCommonApiMixin from "@/mixin/em/common/api";
import emCommonListMixin from "@/mixin/em/common/list";
import commonViewsUtil from "@/utils/commonViewsUtil";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import KeyValueCell from "@/views/sithMes/prd/PrdOperationExcute/cells/KeyValueCell";
import CommonPage from "@/components/echarts-part/stuff/CommonPage";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import DiverseInput from "@/components/workflow/stuffs/DiverseInput.vue";

export default {
    name: 'sithMesPrdProjectKamSelection',
    components: {DiverseInput, ReBModal, CommonPage, KeyValueCell, MiniTable},
    mixins: [emCommonApiMixin, emCommonListMixin, emCommonUtilMixin],
    data() {
        return {
            enNetworks: [],
            isKamChange: false,
            projectCode: '',
            projectName: '',
            selectKamDialogVisible: false,
            copyKamDialogVisible: false,
            // 正在从KAM基础数据查询
            inQuery: false,
            // 正在查询项目上的KAM
            inSearchProjectKam: false,
            // 正在保存KAM到当前项目
            savingProjectKam: false,
            //当前项目的KAM
            currentKamList: [],
            currentKamMap: {},
            //搜索KAM的条件
            kamFilter: {
                enNetworkFilter: '',
                enElementNameFilter: '',
                enElementTypeFilter: '',
                enActivityIdFilter: '',

            },
            //搜索出的KAM
            kamList: [],
            //dialog中选择的Kam
            choosenKam: [],
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            //copy项目KAM的搜索结果
            projectKamList: [],
            copyKamFilter: {
                projectCodeFilter: ''
            },
            kamSelectTableFieldConfig: ['enNetwork', 'enNetworkCode', 'enActivityId',
                {key: 'spiridonActivityId', label: 'SAP ID'}, 'enElementName', 'enElementType'
            ],
            queryCurrentKamListLoading: false,
            currentUserRole: null,
            editAble: false,
            needDeleteProjectKamIds: [],
            //-------kam change
            selectedProjectKam: null,
            queryBomLoading: false,
            bomMaterialList: [],
            selectedBomItem: null,
            createKamChangeLoading: false,
            createdKamChange: false,
            changeType: null,//变更类型
            changeTypes: [
                {value: 1, text: 'KAM 变更'},
                {value: 5, text: '工程变更'},
            ]
            //kam change-------
        }
    },
    computed: {
        isEn() {
            return this.currentUserRole && this.currentUserRole === 'EN';
        },
        isOm() {
            return this.currentUserRole && this.currentUserRole === 'OM';
        },
        editTableFields() {
            if (!this.editAble) {
                return [];
            }
            if (this.isEn) {
                return [
                    {
                        key: 'participateAssembly',
                        isInput: true,
                        disableWhen: row => {
                            return row.chooseFrom !== '2' && (row.sapAssignStatus === 1 || row.chooseFrom === '0');
                        }
                    },
                    {
                        key: 'materialNumber',
                        isInput: true,
                        disableWhen: row => {
                            let originProjectKam = this.currentKamMap[row.kamId];
                            return row.chooseFrom !== '2' && (row.sapAssignStatus === 1 || originProjectKam.released);
                        }
                    },
                    {
                        key: 'materialQuantity',
                        isInput: true,
                        disableWhen: row => {
                            let originProjectKam = this.currentKamMap[row.kamId];
                            return row.chooseFrom !== '2' && (row.sapAssignStatus === 1 || originProjectKam.released);
                        }
                    },
                    {
                        key: 'released',
                        isInput: true,
                        type: 'checkbox',
                        disableWhen: row => {
                            let originProjectKam = this.currentKamMap[row.kamId];
                            return row.chooseFrom !== '2' && (row.sapAssignStatus === 1 || originProjectKam.released);
                        },
                        defaultValue: false
                    },
                    {
                        key: 'remark',
                        isInput: true,
                        type: 'textarea',
                        disableWhen: row => {
                            let originProjectKam = this.currentKamMap[row.kamId];
                            return row.chooseFrom !== '2' && (row.sapAssignStatus === 1 || originProjectKam.released);
                        },
                    }
                ];
            } else if (this.isOm) {
                return [
                    {
                        key: 'scope',
                        isInput: true,
                        disableWhen: row => {
                            let originProjectKam = this.currentKamMap[row.kamId];
                            return row.sapAssignStatus === 1 || (originProjectKam.released && originProjectKam.scope);
                        }
                    },
                    {
                        key: 'materialDirection',
                        isInput: true,
                        options: [
                            {value: 1, text: 'R'},
                            {value: 2, text: '3rd'},
                            {value: 3, text: 'P', disabled: true},
                        ],
                        disableWhen: row => {
                            let originProjectKam = this.currentKamMap[row.kamId];
                            return row.participateAssembly !== false || row.sapAssignStatus === 1 || (originProjectKam.released && originProjectKam.materialDirection);
                        }
                    }
                ];
            } else {
                return [];
            }
        },
        isQueryAll() {
            return !this.projectCode && this.currentUserRole;
        },
        selectKamFilterConfig() {
            return [
                {name: 'enNetworkFilter', config: {label: 'EN Network', type: 'select', options: this.enNetworks}},
                {name: 'enActivityIdFilter', config: {label: 'EN Activity ID', type: 'input'}},
                {name: 'enElementNameFilter', config: {label: 'EN Element Name', type: 'input'}},
                {name: 'enElementTypeFilter', config: {label: 'EN Element Type', type: 'input'}},
            ]
        },
    },
    created() {
        this.isKamChange = this.$route.query.isKamChange === 'true';
        // 根据路径参数设置项目信息
        // 搜索当前操作人在当前项目中已经挑选的KAM
        this.projectName = this.$route.query.projectName;
        this.queryList();
        this.getDistinctNetwork();
    },
    methods: {
        queryList() {
            let projectCode = this.$route.query.projectCode;
            if (projectCode !== undefined && projectCode != null) {
                this.projectCode = projectCode;
                this.findKamUnderCurrentUser(projectCode);
            } else {
                let userRole = this.$route.query.currentUserRole;
                console.log('userRole', userRole);
                if (this.hasCode(userRole)) {
                    this.currentUserRole = userRole;
                    this.findProjectKamListByUserRole();
                }
            }
        },
        handleRemoteKamList: function (tempList) {
            for (let item of tempList) {
                item.chooseFrom = '0';
            }
            this.currentKamList = tempList;
            this.currentKamListToMap();
            this.needDeleteProjectKamIds = [];//reset after query
        },
        findKamUnderCurrentUser(projectCode) {
            this.queryCurrentKamListLoading = true;
            let url = `${this.$_emApiMixin_entityBaseApi('sithMesPrdProjectKam')}/findKamUnderCurrentUser?projectCode=${projectCode}`
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    console.log(response);
                    if (response.data) {
                        this.handleRemoteKamList(response.data.list);
                        this.currentUserRole = response.data.caption;
                    }
                }).finally(() => this.queryCurrentKamListLoading = false);
        },
        findProjectKamListByUserRole() {
            this.queryCurrentKamListLoading = true;
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdProjectKam/findProjectKamOf" + this.currentUserRole,
                data: {}
            }).then(response => {
                console.log(response);
                if (response.data) {
                    this.handleRemoteKamList(response.data);
                }
            }).finally(() => this.queryCurrentKamListLoading = false);
        },
        openSelectDialog() {
            this.$refs.selectKam.showModal();
        },
        // 项目中已保存的KAM不可在此处选中进行删除
        checkSelectable(row, index) {
            if (row.chooseType > '0') {
                return true;
            } else {
                return false;
            }
        },
        // 清空搜索KAM基础数据的条件
        clearFilter() {
            this.inQuery = false;
            // this.kamList = [];
            this.choosenKam = [];
            // this.kamFilter.enNetworkFilter = '';
            // this.kamFilter.enElementNameFilter = '';
            // this.kamFilter.enElementTypeFilter = '';
            // this.kamFilter.enActivityIdFilter = '';
        },
        openCopyDialog() {
            this.copyKamDialogVisible = true;
        },
        // 清空查询项目下已选KAM时的搜索条件
        clearCopyFilter() {
            this.inSearchProjectKam = false;
            this.projectKamList = [];
            this.copyKamFilter.projectCode = '';
        },
        // 从KAM基础数据搜索对应条件KAM
        searchKam() {
            let self = this;
            self.inQuery = true;
            let url = `${this.$_emApiMixin_entityBaseApi("sithMesMstKam")}/searchKam`
            self.$_emApiMixin_post(url, self.kamFilter)
                .then(response => {
                    self.kamList = response.data;
                }).finally(() => self.inQuery = false);
        },
        // 搜索指定项目下已挑的KAM
        searchProjectKam() {
            let self = this;
            self.inSearchProjectKam = true;
            let url = `${this.$_emApiMixin_entityBaseApi("sithMesPrdProjectKam")}/findProjectKamByProjectCode?projectCode=${self.copyKamFilter.projectCode}`
            self.$_emApiMixin_post(url, {})
                .then(response => {
                    //将返回结果转换成树需要的数据格式
                    if (Array.isArray(response.data) && response.data.length > 0) {
                        let kamList = response.data.map(kam => {
                            return Object.assign(kam, {
                                label: kam.enNetwork + ' | ' + kam.enNetworkCode + ' | '
                                    + kam.enElementType + ' | ' + kam.enElementName
                            })
                        });
                        //将KAM按照项目号分组
                        let projectMap = this._toMapList(kamList, 'projectCode');
                        for (let code of Array.from(projectMap.keys())) {
                            let items = projectMap.get(code);
                            if (items) {
                                let temp = {
                                    id: code,
                                    label: code + '-' + items[0].projectName,
                                    level: '1',
                                    children: []
                                };
                                //按工程师分组
                                let engMap = this._toMapList(items, 'engineerName');
                                for (let eng of Array.from(engMap.keys())) {
                                    let list = engMap.get(eng);
                                    if (list) {
                                        let engObj = {
                                            id: eng, label: eng, level: '2',
                                            children: _.orderBy(list, 'label', 'asc')
                                        };
                                        temp.children.push(engObj);
                                    }
                                }
                                self.projectKamList.push(temp);
                            }
                        }
                    }

                }).finally(() => self.inSearchProjectKam = false);
        },
        // 重置搜索KAM基础数据的条件--重置按钮用
        resetFilter() {
            this.kamList = [];
            this.kamFilter.enNetworkFilter = '',
                this.kamFilter.enElementNameFilter = '',
                this.kamFilter.enElementTypeFilter = '',
                this.kamFilter.enActivityIdFilter = ''
        },
        // 从KAM基础数据选择弹框中，左侧选中时触发
        chooseKam(row) {
            let indexOf = this.choosenKam.indexOf(row);
            if (indexOf === -1) {
                this.choosenKam.push(row);
            } else {
                this.choosenKam.splice(indexOf, 1);
            }
        },
        // 从KAM基础数据选择弹框中，右侧删除触发
        handleDelete(row, index) {
            this.choosenKam.splice(index, 1);
        },
        // 将从KAM基础数据中选择的KAM放入已选中的列表
        assignKamToProject() {
            let currentKamIds = this.currentKamList.map(currentKam => {
                return currentKam.kamId
            });
            this.choosenKam.forEach(kam => {
                if (currentKamIds.indexOf(kam.id) === -1) {
                    let obj = this.deepCopyObj(kam);
                    obj.chooseFrom = '1';
                    obj.kamId = obj.id;
                    obj.id = null;
                    this.currentKamList.push(obj);
                    this.currentKamMap[obj.kamId] = obj;
                }
            });
            this.currentKamList.sort(this.compareKam);
            this.triggerTableEdit(true);
        },
        // 将从其他项目上选中的KAM放入已选中kam列表
        copyKamToProject() {
            let checkedNode = this.$refs.copyKamTree.getCheckedNodes(true, false);
            let currentKamIds = this.currentKamList.map(currentKam => {
                return currentKam.id
            });
            checkedNode.forEach(node => {
                if (currentKamIds.indexOf(node.id) === -1) {
                    let obj = this.deepCopyObj(node);
                    obj.chooseFrom = '2';
                    obj.id = null;
                    obj.scope = null;
                    obj.materialDirection = null;
                    obj.materialNumber = null;
                    obj.materialQuantity = null;
                    obj.participateAssembly = null;
                    obj.released = false;
                    this.currentKamList.push(obj);
                    this.currentKamMap[obj.kamId] = obj;
                }
            });
            this.currentKamList.sort(this.compareKam);
            this.copyKamDialogVisible = false;
            this.triggerTableEdit(true);
        },
        saveProjectKam() {
            let editForm = this.$refs.currentKamListTable.collectInlineEditData();
            console.log(editForm)
            let columnEditData = editForm.editRows;
            if (columnEditData && columnEditData.length > 0 || editForm.deleteIds.length > 0) {
                this.savingProjectKam = true;
                if (!this.isQueryAll) {
                    let kamSet = new Set();
                    for (let row of columnEditData) {
                        if (kamSet.has(row.kamId)) {
                            this.$message.warning('KAM重复');
                            this.savingProjectKam = false;
                            return;
                        } else {
                            kamSet.add(row.kamId);
                        }
                        let temp = this.currentKamList.find(f => f.kamId === row.kamId);
                        if (temp && temp.id) {
                            row.id = temp.id;
                        }
                    }
                }
                let uri = '';
                if (this.isQueryAll) {
                    uri = `/editKam?userRole=${this.currentUserRole}`;
                } else {
                    uri = `/addNewKam?projectCode=${this.projectCode}`;
                }
                this.$store.dispatch('api/post', {
                    url: this.$_emApiMixin_entityBaseApi("sithMesPrdProjectKam") + uri,
                    data: {
                        saveForms: columnEditData,
                        deleteIds: editForm.deleteIds
                    }
                }).then(() => {
                    commonViewsUtil.showSuccess(this, "保存成功");
                    //refresh
                    this.queryList();
                    this.editAble = false;
                }).finally(() => this.savingProjectKam = false);
            }

        },
        compareKam(a, b) {
            let comparison = 0;
            if (a.chooseFrom > b.chooseFrom) {
                comparison = -1;
            } else if (a.chooseFrom < b.chooseFrom) {
                comparison = 1;
            }
            return comparison;
        },
        toKamChange(row) {
            this.selectedProjectKam = row;
        },
        judgeSelected() {
            if (this.selectedProjectKam && this.selectedProjectKam.materialNumber) {
                return true;
            } else {
                this.$message.warning("请先选择有效的KAM行");
                return false;
            }
        },
        queryBom() {
            if (this.judgeSelected()) {
                this.queryBomLoading = true;
                this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_SITHMES_MST_URL + "/sithMesMstMaterial/queryBom?materialNumber=" + this.selectedProjectKam.materialNumber,
                    data: {}
                }).then(response => {
                    this.bomMaterialList = response.data;
                }).finally(() => this.queryBomLoading = false);
            }
        },
        selectBomRow(row) {
            this.selectedBomItem = row;
        },
        cancelBomItemSelect() {
            this.bomMaterialList = [];
            this.selectedBomItem = null;
        },
        createKamChange() {
            if (this.judgeSelected()) {
                if (this.changeType == null) {
                    this.$message.error("请选择变更类型");
                    return;
                }
                this.createKamChangeLoading = true;
                let materialNumber = this.selectedProjectKam.materialNumber;
                if (this.selectedBomItem && this.selectedBomItem.componentNumber) {
                    materialNumber = this.selectedBomItem.componentNumber;
                }
                this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdKamChange/createKamChange",
                    data: {
                        projectKamId: this.selectedProjectKam.id,
                        materialNumber: materialNumber,
                        changeType: this.changeType
                    }
                }).then(() => {
                    this.$message.success("发起成功");
                    this.createdKamChange = true;
                }).finally(() => this.createKamChangeLoading = false);
            }
        },
        routeToKamChange() {
            this.$router.push("/sithMes/prd/sithMesPrdKamChangeList?pathType=todo")
        },
        getDistinctNetwork() {
            this.$store.dispatch('api/get', {
                url: process.env.VUE_APP_SITHMES_MST_URL + "/sithMesMstKam/distinctNetwork"
            }).then(response => {
                this.enNetworks = response;
            });
        },
        whenCurrentKamListRowClick(row) {

        },
        triggerTableEdit(val) {
            if (val !== undefined) {
                this.editAble = val;
            } else {
                this.editAble = !this.editAble;
            }
            this.$nextTick(() => this.$refs.currentKamListTable.initData());
        },
        deleteSelectedRow(row) {
            for (let i = 0; i < this.currentKamList.length; i++) {
                let item = this.currentKamList[i];
                if (item.kamId === row.kamId) {
                    this.currentKamList.splice(i, 1);
                    if (row.chooseFrom === '0' && row.id) {
                        this.needDeleteProjectKamIds.push(row.id);
                    }
                    this.$delete(this.currentKamMap, row.kamId);
                    break;
                }
            }
        },
        lockProjectKam(row) {
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdProjectKam/lock?projectKamIds=" + row.id,
                data: {}
            }).then(() => {
                this.$message.success("Lock success");
                this.queryList();
            });
        },
        unlockProjectKam(row) {
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdProjectKam/unlock?projectKamIds=" + row.id,
                data: {}
            }).then(() => {
                this.$message.success("Unlock success");
                this.queryList();
            });
        },

        currentKamListToMap() {
            let tempMap = {};
            for (let row of this.currentKamList) {
                tempMap[row.kamId] = row;
            }
            this.currentKamMap = tempMap;
        },
    }
}
</script>
<style scoped>
.tree-bom-div {
    height: 285px;
    overflow: auto;
}

.tree-bom-div ::v-deep .el-checkbox {
    width: 20px;
}

.modal >>> .modal-lg {
    max-width: 80% !important;
}
</style>
